import { render, staticRenderFns } from "./SettingsBotSummary.vue?vue&type=template&id=6d7e8f40&"
import script from "./SettingsBotSummary.vue?vue&type=script&lang=js&"
export * from "./SettingsBotSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports